// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateDataForUnparse,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";

export const XngCreateDataForUnparse: any = (props: any) => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    props.dataForUnparse = {
        fields: [
            translate("Item #"),
            translate("MFG #"),
            translate("Quantity"),
            translate("Unit of Measure"),
            translate("Brand"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("Added on"),
            translate("Added by"),
        ],
        data: wishListLineCollection.map((o: WishListLineModel) => {
            let notes = "";
            const lineGroups = JSON.parse(o.properties.grouping);
            lineGroups.forEach((group: any) => {
                if (notes.length >= 300) {
                    return;
                }
                notes += `${notes.length > 0 && notes !== " " ? " " : ""}${group.notes}`;
            });

            return [
                o.erpNumber,
                o.manufacturerItem,
                o.qtyOrdered.toString(),
                o.unitOfMeasure,
                o.brand?.name || "",
                o.shortDescription,
                o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
                notes,
                o.createdOn.toString(),
                o.createdByDisplayName,
            ];
        }),
    };
};

replaceInChain(chain, CreateDataForUnparse, XngCreateDataForUnparse);
